import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import { View } from '../../../components/Base';
import Button from '../../../components/Button';
import { FINISHED, RESET, SEARCH } from '../../../constants/strings';
import palette from '../../../components/styles/palette';

const useStyles = makeStyles(() => ({
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  yellowButton: {
    backgroundColor: palette.yellow,
    border: palette.yellowBorder,
    color: palette.typography.black.solid,
    '&:hover': {
      backgroundColor: palette.yellow,
    },
  },

  blueButton: {
    backgroundColor: palette.btn.blueFill,
    border: palette.btn.blueBorder,
    '&:hover': {
      backgroundColor: palette.btn.blueFill,
    },
  },

  greenButton: {
    backgroundColor: palette.modalButtons.green,
    border: palette.modalButtons.greenBorder,
    '&:hover': {
      backgroundColor: palette.modalButtons.green,
    },
    '&:disabled': {
      border: `1px solid ${palette.liteGreen}`,
    },
  },
}));

const ParcelSearchButtons = ({
  handleSearch,
  handleReset,
  handleFinish,
  disableSearchButton,
}) => {
  const classes = useStyles();

  return (
    <View className={classes.buttonContainer}>
      <Button
        minWidthZero
        onClick={handleSearch}
        className={classes.greenButton}
        disabled={disableSearchButton}
        bgColorDisabled={palette.liteGreen}
        data-testid="parcel-search-button"
      >
        {SEARCH}
      </Button>
      <Button
        minWidthZero
        onClick={handleReset}
        className={classes.yellowButton}
        data-testid="parcel-reset-button"
      >
        {RESET}
      </Button>
      <Button
        minWidthZero
        onClick={handleFinish}
        className={classes.blueButton}
        data-testid="parcel-finished-button"
      >
        {FINISHED}
      </Button>
    </View>
  );
};

export default memo(ParcelSearchButtons);
